import React from 'react';
import { useMutation } from '@tanstack/react-query';
import { unbindDomain } from '../apis';
import { toast } from 'react-toastify';

const useUnbindDomain = () => {
  const mutationData = useMutation({
    mutationFn: unbindDomain,
    onSuccess: (data) => {
      toast.success('Delete domain successfully');
    },
    onError: (error) => {
      const message = error?.response?.data?.message ?? 'Server error';
      toast.error(message);
      console.error('Error Delete  domain:', error);
    },
  });

  return mutationData;
};

export default useUnbindDomain;
